import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function EditIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="9.5" fill="transparent" stroke="currentColor"/>
      <path d="M9.54653 11.348L9.33053 5.6H10.6865L10.4585 11.348H9.54653ZM10.0145 14.072C9.79053 14.072 9.60253 13.996 9.45053 13.844C9.29853 13.692 9.22253 13.512 9.22253 13.304C9.22253 13.08 9.29853 12.896 9.45053 12.752C9.60253 12.608 9.79053 12.536 10.0145 12.536C10.2385 12.536 10.4225 12.608 10.5665 12.752C10.7105 12.896 10.7825 13.08 10.7825 13.304C10.7825 13.512 10.7105 13.692 10.5665 13.844C10.4225 13.996 10.2385 14.072 10.0145 14.072Z" fill="currentColor"/>
    </SvgIcon>
  );
}
